import type { I_KnowledgeGraph } from '../interfaces'
import { ListNames } from '../config/configuration'
import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { loadBlobFilesForItem } from './detailview'

export const getKnowledgeGraphData = async (): Promise<I_KnowledgeGraph[]> => {
  try {
    const list = await rhybusRListsHttp().getList(ListNames.KNOWLEDGEGRAPH)
    const items = [...(await list.query().orderBy([{ orderBy: 'ItemModified', ascending: false }]).get<I_KnowledgeGraph>())]
    const mapped = (items ?? []).filter((item: I_KnowledgeGraph) => !item.IsDeleted && item.IsArchived === false).map((item: any) => ({
      ...item,
      AttachmentFiles: item.AttachmentFiles ?? [],
      ItemModifiedBy: typeof item.ItemModifiedBy === 'string' ? { Title: item.ItemModifiedBy } : item.ItemModifiedBy,
      ItemCreatedBy: typeof item.ItemCreatedBy === 'string' ? { Title: item.ItemCreatedBy } : item.ItemCreatedBy,
    }))
    await Promise.all(mapped.map(async (item: any) => {
      if (!item.eKey) return
      const files = await loadBlobFilesForItem(item.eKey, 'knowledge-base', 'knowledge-base')
      if (files.length > 0) item.AttachmentFiles = files
    }))
    return mapped
  }
  catch (error) {
    console.error('Failed to fetch Knowledge Base data:', error)
    return []
  }
}

export const knowledgeGraphItems = await getKnowledgeGraphData()
